/*
* t9所有需要挂载全局的一些api，统一集中到这里管理
* TODO: 后续将public文件目录下的一些公共js中的方法与变量转移到这里，持续优化
*/

// 基础类
import Base from './base'

window.LQAPI = {
  ...Base,
  C9BS_CALL_CAR: 'C9BS调车版', // 收归C9BS调车版常量定义

    /**
   * What（是什么）：LQ 版本的 lodash
   * Why（为什么）： 沉淀蓝桥全局公共函数，方便进行全局提效和工程质量管控
   * How（怎么做）：
   *    1. 将常用的函数进行封装，提供给全局使用
        2. https://devstatic.amh-group.com/ltl-tech/pages/component/common/basic.html 在这个范围内的，不要再造轮子
        3. 能用 lodash、dayjs、等函数库的尽量使用这些库
        4. 要有单元测试/出入参
        5. 要有明确的第一负责人
        6. 后期代码改动均需要由函数的第一负责人进行审核
    */
  fn: {
    /**
     * 诞生背景：https://code.amh-group.com/lanqiao-saas/lq-saas-web/-/merge_requests/7017#note_5180121
     * 递归过滤 vif，
     * @param arr 需要过滤的数组
     * 作者 贠灿飞
     */
    filterVif: (arr) => {
      if (!Array.isArray(arr)) {
        throw new Error('filterVif: 参数 arr 必须是一个数组');
      }
      return arr.filter(item => {
          // 过滤 vif 属性
          return item.vif === true || item.vif === undefined;
       
      })
    }
  },
}


